export default {"src":"/_next/static/media/outOfStockReview.2dad0f7f.svg","height":64,"width":32,"blurWidth":0,"blurHeight":0};